/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import moment  from 'moment';
import * as Excel from 'exceljs';

import { FormatCamelCasePipe } from './../pipes/format-camel-case.pipe';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xls';

export enum EXCEL_FILENAMES {
  CUSTOM_PROJECTS_LIST = 'Custom_Projects_list',
  BILLING_DATA = 'Billing_Data',
}

@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  constructor(private camelCasePipe: FormatCamelCasePipe) {}

  public async exportGenericFile(jsonData: any[], worksheetName: EXCEL_FILENAMES | string): Promise<void> {
    const workbook = new Excel.Workbook();

    const worksheet = workbook.addWorksheet(worksheetName);
    const header = Object.keys(jsonData[0]).map((key) => this.camelCasePipe.transform(key));
    worksheet.addRow(header);

    for (const x1 of jsonData) {
      const x2 = Object.keys(x1);
      const temp: any[] = [];
      for (const y of x2) {
        temp.push(x1[y]);
      }
      worksheet.addRow(temp);
    }

    this.formatColumnsAndRows(worksheetName, worksheet);

    // add data and file name and download
    const data = await workbook.xlsx.writeBuffer();

    this.saveAsExcelFile(data, worksheetName);
  }

  private formatColumnsAndRows(worksheetName: EXCEL_FILENAMES | string, worksheet: any): void {
    worksheet.columns.forEach((column: any) => {
      column.width = 15;
    });
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_Export_' + moment(new Date()).format('YYYY.MM.DDTh.mm.ss') + EXCEL_EXTENSION);
  }
}
